import React, { Component } from "react";
import HomeResultsRow from "./HomeResultsRow";
import { Button } from "antd";
import { Alert, Images } from "../../../components";
import { connect } from "react-redux";
import { getLuckyNumbersEventResultRequest } from "../../../redux/actions/sportTypesActions";
import { withRouter } from "react-router";
import { loadUpcomingDraws } from "../../../redux/actions/sportTypesActions";
import { resetUpcomingDraws } from "../../../redux/actions/sportTypesActions";

export class HomeResults extends Component {
  componentDidUpdate(prevProps) {
    const { match , fromNextDraws , upcomingDrawsEvents , luckyNumbersRefreshTime} = this.props;

    if (!prevProps.connected && this.props.connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
        },
      };
      if(fromNextDraws){
        this.props.loadUpcomingDraws({Data:{...request.Data }} , false);
      }else{
        this.props.getLuckyNumbersEventResultRequest(request, false);
      }
      
    }
    if (
      this.props.connected && prevProps.upcomingDrawsEvents &&
      prevProps.upcomingDrawsEvents !== upcomingDrawsEvents &&
      !this.timeout && localStorage.getItem("refreshUpcomingDrawsEvents") && this.props.fromNextDraws
    ) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let drawsRequest = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: 0,
          },
        };
        this.props.loadUpcomingDraws(drawsRequest, false);
        this.timeout = null; // Clear the timeout reference after it has executed
        localStorage.removeItem("refreshUpcomingDrawsEvents")
      }, luckyNumbersRefreshTime * 1000);
    }
  }
  componentDidMount() {
    const { getLuckyNumbersEventResultRequest, match, connected ,fromNextDraws } = this.props;

    if (connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
        },
      };
      if(fromNextDraws){
        this.props.loadUpcomingDraws({Data:{...request.Data ,}} , false);
      }else{
        this.props.getLuckyNumbersEventResultRequest(request, false);
      }
    }
  }
  componentWillUnmount(){
    this.props.resetUpcomingDraws();
    localStorage.removeItem("refreshUpcomingDrawsEvents");
    clearTimeout(this.timeout);
  }

  loadMore = () => {
    const {
      getLuckyNumbersEventResultRequest,
      match,
      connected,
      updatePageIndex,
      fromNextDraws
    } = this.props;
    if (connected) {
      console.log("this.props.formatedDate",this.props.formatedDate);
      if (this.props.formatedDate) {
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: this.props.pageIndex + 1,
            dateOfMatch: this.props.formatedDate,
          },
        };
        if(fromNextDraws){
          this.props.loadUpcomingDraws({Data:{...request.Data }} , true);
        }else{
          getLuckyNumbersEventResultRequest(request, true);
        }
      }else if (this.props.gameId){
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: this.props.pageIndex + 1,
            tournamentId: this.props.gameId
          },
        };
          getLuckyNumbersEventResultRequest(request, true);
        
      } else {
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: this.props.pageIndex + 1,
          },
        };
        if(fromNextDraws){
          this.props.loadUpcomingDraws({Data:{...request.Data}} , true);
        }else{
          getLuckyNumbersEventResultRequest(request, true);
        }
      }
      updatePageIndex();
    }
  };

  render() {
    const {
      loadingEventResult,
      luckyNumbersEventResult,
      luckyNumbersEventResultError,
      loadingUpcomingDraws,
      upcomingDrawsEvents,
      upcomingDrawsEventsError,
      fromNextDraws,
      luckyNumberResultsPageTexts,
      fromResult
    } = this.props;
    const data = fromNextDraws ? upcomingDrawsEvents && Object.values(upcomingDrawsEvents) : luckyNumbersEventResult 
    if (loadingUpcomingDraws && fromNextDraws  || !this.props.connected  ) {
      return (
        <div className="lds-parent-ring">
          <div class="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      );
    }
    if (loadingEventResult && fromResult || !this.props.connected ) {
      return (
        <div className="lds-parent-ring">
          <div class="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      );
    }
    if (luckyNumbersEventResultError && fromResult ) {
      return (
        <Alert
          type={"error"}
          message={luckyNumbersEventResultError }
        />
      );
    }
    if (upcomingDrawsEventsError && fromNextDraws ) {
      return (
        <Alert
          type={"error"}
          message={upcomingDrawsEventsError }
        />
      );
    }
    return (
      <>
        {(data) ? (
          <div className="latest-results-container">
            {!this.props.fromResultOrNextDraw && <h2>Latest Results</h2>}
            <div className="results">
              {data.map((item, idx) => {
                return (
                  idx % 2 == 0 && (
                    <HomeResultsRow
                      fromResult={this.props.fromResult}
                      history={this.props.history}
                      key={idx}
                      fromNextDraws={this.props.fromNextDraws}
                      item1={item}
                      item2={data[idx + 1]}
                    />
                  )
                );
              })}
              <div
                className="go-to-results"
                style={
                  this.props.fromResultOrNextDraw
                    ? { justifyContent: "center" }
                    : {}
                }
              >
                {this.props.fromResultOrNextDraw ? (
                  <div>
                    <Button style={this.props.drawId ? {cursor:"not-allowed"}:{}} onClick={() => !this.props.drawId && this.loadMore()}>
                      Load more <img src={Images.RightArrowIcon} alt="arrow" />
                    </Button>
                  </div>
                ) : (
                  <div>
                    <Button onClick={() => this.props.nav("results")}>
                      Go to results{" "}
                      <img src={Images.RightArrowIcon} alt="arrow" />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connected: state.signalr.luckyNumbersConnected,
    loadingEventResult: state.sportTypes.loadingEventResult,
    luckyNumbersEventResult: state.sportTypes.luckyNumbersEventResult,
    luckyNumbersEventResultError: state.sportTypes.luckyNumbersEventResultError,
    loadingUpcomingDraws: state.sportTypes.loadingUpcomingDraws,
    upcomingDrawsEvents: state.sportTypes.upcomingDrawsEvents,
    upcomingDrawsEventsError: state.sportTypes.upcomingDrawsEventsError,
    luckyNumbersRefreshTime: state.general.configuration.luckyNumbersRefreshTime,


  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLuckyNumbersEventResultRequest: (item, addToEvents) => {
      dispatch(getLuckyNumbersEventResultRequest(item, addToEvents));
    },
    loadUpcomingDraws: (item , addNewList) => {
      dispatch(loadUpcomingDraws(item , addNewList));
    },
    resetUpcomingDraws: () => {
      dispatch(resetUpcomingDraws());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeResults);
